import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Observable } from 'rxjs'
import { Device, Group, User } from '../../models'
import { GroupService } from '../../services/group.service'
import { Helpers } from './../../../../helpers'
import { Content } from './../../models/content.model'
import { ContentService } from './../../services/content.service'
import { DeviceService } from './../../services/device.service'

@Component({
  selector: 'manage-contents',
  styleUrls: ['./modal-mod.css'],
  templateUrl: './manage-contents.modal.html'
})
export class ManageContentsModal {
  @Input() public device: Device
  @Input() public selectedGroup: Group
  @Input() public allContents: Content[]
  @Input() public contents: Content[]
  @Output()
  public allContentsChange: EventEmitter<Content[]> = new EventEmitter()
  @Output() public deviceChange: EventEmitter<Device> = new EventEmitter()
  public progressPercentage: number = 0

  public contentSearchInput
  public contentSearchInput2

  constructor(
    private _groupService: GroupService,
    private _deviceService: DeviceService
  ) { }

  public init() {
    this.allContents = this.allContents.sort((d1, d2) => {
      const x = d1.name
      const y = d2.name
      return x < y ? -1 : x > y ? 1 : 0
    })
    if (this.selectedGroup) this.getContentsByGroup()
    if (this.device) this.contents = this.device.contents
  }

  public getContentsByGroup() {
    this._groupService.getById(this.selectedGroup._id).subscribe((group) => {
      Helpers.setLoading(false)
      this.contents = group.contents
      // sort by name
      this.contents = this.contents.sort((d1, d2) => {
        const x = d1.name
        const y = d2.name
        return x < y ? -1 : x > y ? 1 : 0
      })

      // remove from 'allContents' the contents on the group
      this.contents.forEach((c1) => {
        this.allContents.forEach((c2, index) => {
          if (c1._id == c2._id) {
            this.allContents.splice(index, 1)
          }
        })
      })
    })
  }

  public removeContentFromDevice(content: Content) {
    if (this.selectedGroup) {
      this.removeContentsFromGroup(content)
    } else {
      this._deviceService
        .unsubscribeContentToDevice(content._id, this.device._id)
        .subscribe((data) => {
          if ('completion' in content) delete content.completion
          this.device.contents = data
          this.allContents.unshift(content)
          this.contents = this.contents.filter(function (cont) {
            return cont._id !== content._id
          })
          this.updateParent()
        })
    }
  }

  public addContentToDevice(content) {
    if (this.selectedGroup) {
      this.addContentsToGroup(content)
    } else {
      this._deviceService
        .subscribeContentToDevice(content.id, this.device._id)
        .subscribe(
          (data) => {
            this.device.contents = data
            this.contents.unshift(content)
            this.allContents = this.allContents.filter(function (cont) {
              return cont._id !== content.id
            })
            this.updateParent()
          },
          (error) => { }
        )
    }
  }

  public addContentsToGroup(content: Content) {
    this._groupService
      .addContentToGroup(this.selectedGroup._id, content._id)
      .subscribe((data) => {
        this.contents.unshift(content)
        this.allContents = this.allContents.filter(function (cont) {
          return cont._id !== content._id
        })
      })
  }

  public removeContentsFromGroup(content: Content) {
    this._groupService
      .removeContentFromGroup(this.selectedGroup._id, content._id)
      .subscribe((data) => {
        this.allContents.unshift(content)
        this.contents = this.contents.filter(function (cont) {
          return cont._id !== content._id
        })
      })
  }

  private updateParent() {
    if (this.device) this.device.contents = this.contents
    this.allContentsChange.emit(this.allContents)
    this.deviceChange.emit(this.device)
  }
}
